__turbopack_context__.v({
  "checkbox": "CollapsibleContent-module__Yzc3tG__checkbox",
  "code": "CollapsibleContent-module__Yzc3tG__code",
  "codeBlock": "CollapsibleContent-module__Yzc3tG__codeBlock",
  "collapseLabel": "CollapsibleContent-module__Yzc3tG__collapseLabel",
  "container": "CollapsibleContent-module__Yzc3tG__container",
  "expandLabel": "CollapsibleContent-module__Yzc3tG__expandLabel",
  "toggle": "CollapsibleContent-module__Yzc3tG__toggle",
});
